let plugin = require("tailwindcss/plugin")

module.exports = {
    content: [
        "./vendor/laravel/framework/src/Illuminate/Pagination/resources/views/*.blade.php",
        "./storage/framework/views/*.php",
        "./resources/css/**/*.css",
        "./resources/js/**/*.js",
        "./resources/views/**/*.blade.php",
    ],

    theme: {
        screens: {
            xs: "475px",
            sm: "640px",
            md: "768px",
            lg: "1024px",
            xl: "1280px",
            "2xl": "1440px",
        },
        extend: {
            fontFamily: {
                base: ["Roboto Condensed", "arial", "sans-serif"],
            },
            fontSize: {
                // xs: ['0.75rem', { lineHeight: '1rem' }],
                xs: ["0.625rem", { lineHeight: "1rem" }], //10px
                sm: "0.75rem", //12px
                base: "0.875rem", //14px
                lg: "1rem", //16px
                xl: "1.125rem", //18px
                "2xl": ["1.375rem", { lineHeight: "1.55rem" }], //22px
                "3xl": ["1.625rem", { lineHeight: "1.75rem" }], //26px
                "4xl": ["1.875rem", { lineHeight: "1.875rem" }], //30px
            },
            colors: {
                "ben-blue": {
                    50: "#fafdff",
                    100: "#F5FBFF",
                    150: "#92B7D3",
                    200: "#63A3DD",
                    300: "#3F7AAF",
                    400: "#294864",
                    500: "#0D2438",
                    600: "#0D2438",
                    700: "#0D2438",
                    800: "#0D2438",
                    900: "#0D2438",
                },
                "ben-black": {
                    DEFAULT: "#000000",
                },
                "ben-green": {
                    DEFAULT: "#007D6C",
                    100: "#37C3B0",
                    200: "#5FCFC0",
                },
                "ben-grey": {
                    100: "#E9E9E9",
                    600: "#6A6A6A",
                    700: "#5A5A5A",
                },
                "ben-yellow": {
                    500: "#ff9000",
                },
                "ben-orange": "#fbeccc",
                current: "currentColor",
            },
            margin: {
                "1/24": "4.166665%",
                "1/12": "8.333333%",
            },
            ringColor: (theme) => ({
                DEFAULT: theme("colors.ben-blue.200"),
            }),
            spacing: {
                header: "var(--header-height)",
            },
            typography: (theme) => ({
                DEFAULT: {
                    css: {
                        color: theme("colors.ben-grey.700"),
                        "line-height": "1.5",
                        margin: "0 auto",
                        "max-width": "120ch",
                        h2: {
                            color: theme("colors.ben-blue.400"),
                            "text-transform": "uppercase",
                            clear: "left"
                        },
                        h3: {
                            clear: "left"
                        },
                        h4: {
                            clear: "left"
                        },
                        hr: {
                            clear: "left"
                        },
                        a: {
                            color: theme("colors.ben-blue.200")
                        },
                        img: {
                            height: "auto !important",
                            "max-height": "100%",
                            "object-fit": "contain"
                        },
                        figure: {
                            "text-align": "center"
                        },
                        iframe: {
                            margin: "0 auto"
                        },
                        strong: {
                            color: "inherit"
                        },
                        ol: {
                            display: "inline-block"
                        },
                        ul: {
                            display: "inline-block"
                        },
                    },
                },
            }),
        },
    },

    plugins: [
        require("@tailwindcss/forms"), // https://github.com/tailwindlabs/tailwindcss-forms
        require("@tailwindcss/line-clamp"), // https://github.com/tailwindlabs/tailwindcss-line-clamp
        require("@tailwindcss/typography"), // https://github.com/tailwindlabs/tailwindcss-typography
        plugin(function ({ addVariant }) {
            addVariant("touch", "@media (pointer: coarse)")
            addVariant("no-touch", "@media (pointer: fine)")
        }),
    ],
}
